import waitingComponent from './index.vue'
let $vm;

export default{
  install(Vue,options){
    if(!$vm){
      const waitingPlugin = Vue.extend(waitingComponent);
      $vm = new waitingPlugin({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }
    $vm.show = false;
    let waiting = {
      show(wType){
        console.log($vm)
        $vm.wType = wType;
        $vm.show = true;
      },
      hide(){
        $vm.show = false;
      }
    };
    if(!Vue.$waiting){
      Vue.$waiting = waiting;
    }
    Vue.mixin({
      created(){
        this.$waiting = Vue.$waiting;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugin/waiting/index.js